import { render, staticRenderFns } from "./missing_items.vue?vue&type=template&id=39f67808"
import script from "./missing_items.vue?vue&type=script&lang=js"
export * from "./missing_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports